
import DrawBase from "../DrawBase"
import EditPolyline from "./EditPolyline"
import StyleUtil from "@/utils/cesiumBD/utils/StyleUtil.js"
class DrawPolyline extends DrawBase {

    constructor(options) {
        super(options);
    }



    getEditInterface() {
        return EditPolyline;
    }

    getTypeName() {
        return "线";
    }

    getType() {
        return "polyline_Nor";
    }

    addDynamicGraph(entity) {
        var $this = this;
        var positionsArr = undefined;
        var positionsProperty = new $this.Cesium.CallbackProperty(function () {
            $this.calculateKeyPositions();
            if (!$this.isStarted && !positionsArr) {
                positionsArr = $this.positions.slice();
                return positionsArr;
            }
            return positionsArr ? positionsArr : $this.positions;
        }, false);

        var polyline = this.createPolyline(positionsProperty);
        entity.polyline = polyline;
    }

    loadDynamicGraph(entity, data) {

        var $this = this;
        var positionsArr = JSON.parse(data.editPositions);
        var positionsProperty = new $this.Cesium.CallbackProperty(function () {
            return positionsArr;
        }, true);

        var polyline = this.createPolyline(positionsProperty);
        entity.polyline = polyline;

        StyleUtil.setStyle2Entity(JSON.parse(data.styleAttr), entity, "polyline")

    }
}

export default DrawPolyline